import { Notify } from 'quasar'

function copied (message) {
  Notify.create({
    message: message,
    position: 'top'
  })
}

function download (response, fileName) {
  const blob = response instanceof Blob ? response : new Blob([response])
  const href = URL.createObjectURL(blob)

  const link = document.createElement('a')
  link.style.display = 'none'
  link.href = href
  link.download = fileName

  document.body.appendChild(link)
  link.click()
  setTimeout(() => {
    document.body.removeChild(link)
    URL.revokeObjectURL(href)
  }, 100)
}

// "async" is optional;
// more info on params: https://quasar.dev/quasar-cli/boot-files
export default async ({ Vue }) => {
  Vue.prototype.$copied = copied
  Vue.prototype.$download = download
}
